export function storageItem<T = any>(st: Storage, key: string) {
  return {
    get: tryCatch(() => {
      const value = st.getItem(key)
      if (value === null) { return }
      return JSON.parse(value) as T
    }),
    set: tryCatch((value: T) => st.setItem(key, JSON.stringify(value))),
    del: tryCatch(() => st.removeItem(key)),
  }
}

function tryCatch<A extends any[], R>(func: (...args: A) => R) {
  return function (...args: A): R | (R extends void ? never : undefined) {
    try {
      return func(...args)
    } catch (err) {
      return undefined as unknown as R
    }
  }
}
